import { withAssetVersion } from "./cdn-asset.util";

const MODULES_ICON_BASE_URL =
    "https://cdn.omnicasaassets.com/public/omnicasaresources/icons/modules";

export interface ModuleIconUrls {
    NORMAL: string;
    ACTIVE: string;
    GROUPED?: string;
}

const build = (file: string, hasGrouped: boolean = true): ModuleIconUrls => ({
    NORMAL: withAssetVersion(`${MODULES_ICON_BASE_URL}/${file}.svg`),
    ACTIVE: withAssetVersion(`${MODULES_ICON_BASE_URL}/${file}-active.svg`),
    ...(hasGrouped ? { GROUPED: withAssetVersion(`${MODULES_ICON_BASE_URL}/${file}-grouped.svg`) } : {})
});

export const MODULE_ICON_URLS: Record<string, ModuleIconUrls> = {
    "agenda": build("agenda"),
    "agenda-edit": build("agenda-edit"),
    "agenda-new": build("agenda-new"),
    "company-edit": build("company-edit"),
    "company-new": build("company-new"),
    "company-view": build("company-view"),
    "configuration": build("configuration"),
    "contacts": build("contacts"),
    "dashboard": build("dashboard"),
    "demand-edit": build("DemandEdit"),
    "demand-list": build("Demands"),
    "demand-new": build("DemandPlus"),
    "demand-view": build("Demand"),
    "emails": build("email"),
    "enquiry-task": build("enquiry-task"),
    "kanban": build("kanban"),
    "management": build("management"),
    "marketing": build("marketing"),
    "my-account": build("my-account"),
    "person-edit": build("person-edit"),
    "person-new": build("person-new"),
    "person-view": build("person-view"),
    "project-edit": build("project-edit"),
    "project-new": build("project-new"),
    "project-view": build("project-view"),
    "properties": build("properties"),
    "property-edit": build("property-edit"),
    "property-new": build("property-new"),
    "property-view": build("property-view"),
    "settingv2": build("settingv2"),
    "task-edit": build("task-edit"),
    "task-list": build("task-list"),
    "task-new": build("task-new"),
    "task-view": build("task-view"),
    "video-management": build("video-management")
};

const buildNavbarNormal = (file: string): string =>
    withAssetVersion(`${MODULES_ICON_BASE_URL}/${file}-navbar.svg`);

export const NAVBAR_NORMAL_ICON_URLS: Record<string, string> = {
    "agenda": buildNavbarNormal("agenda"),
    "configuration": buildNavbarNormal("configuration"),
    "contacts": buildNavbarNormal("contacts"),
    "dashboard": buildNavbarNormal("dashboard"),
    "demand-list": buildNavbarNormal("Demand"),
    "emails": buildNavbarNormal("email"),
    "enquiry-task": buildNavbarNormal("enquiry-task"),
    "kanban": buildNavbarNormal("kanban"),
    "management": buildNavbarNormal("management"),
    "marketing": buildNavbarNormal("marketing"),
    "properties": buildNavbarNormal("properties"),
    "task-list": buildNavbarNormal("task"),
    "video-management": buildNavbarNormal("video-management")
};

export const NAVBAR_ICON_KEY_BY_NAME: Record<string, string> = {
    "property": "properties",
    "client": "contacts",
    "demand": "demand-list",
    "agenda": "agenda",
    "task": "task-list",
    "digital-signature": "management",
    "configuration": "configuration",
    "video-management": "video-management",
    "dashboard": "dashboard",
    "kanban": "kanban",
    "emails": "emails",
    "enquiry-centre": "enquiry-task",
    "marketing": "marketing"
};
